import Checkout from './Checkout.vue';

export { Checkout };
export default Checkout;
